import { useQuery } from "@tanstack/react-query";
import { getStudentLearningPaths } from "../../../api/endpoints/LearningPathEndpoints";

export default function useGetStudentLearningPaths() {
  return useQuery({
    queryKey: ["student-learning-paths"],
    queryFn: getStudentLearningPaths,
  });
}
